"use client";
import { IconButton as IconButton$1 } from "@mui/material";
import { styled } from "@mui/material/styles";
const COMPONENT_NAME = "IconButton";
const IconButton = styled(IconButton$1, {
  // Make sure props are forwarded
  shouldForwardProp: () => true
})`
    :focus-visible {
        outline-offset: 2px;
        outline: 2px solid Highlight;
        outline: 2px solid -webkit-focus-ring-color;
    }
`;
IconButton.defaultProps = {
  "automation-id": "ID MISSING"
};
IconButton.displayName = COMPONENT_NAME;
export {
  IconButton
};
